export default function CheckmarkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
    >
      <path
        d="M1.31445 5.94546L4.04439 8.05619L9.2548 1.62305"
        stroke="white"
        strokeLinecap="square"
      />
    </svg>
  );
}
